import * as React from "react";
import Layout from "../components/layout";
import { StaticImage } from "gatsby-plugin-image";
import Tabs from "../components/tabs";

const Arrow = () => (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 5L12 11L6 17" stroke="#CDB757" stroke-width="2" />
  </svg>
);

const Phone = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7068 10.2932C15.6141 10.2003 15.5039 10.1265 15.3825 10.0762C15.2612 10.0259 15.1312 10 14.9998 10C14.8685 10 14.7385 10.0259 14.6172 10.0762C14.4958 10.1265 14.3856 10.2003 14.2928 10.2932L12.6988 11.8872C11.9598 11.6672 10.5808 11.1672 9.70685 10.2932C8.83285 9.4192 8.33285 8.0402 8.11285 7.3012L9.70685 5.7072C9.79979 5.61441 9.87353 5.50421 9.92384 5.38289C9.97415 5.26158 10 5.13153 10 5.0002C10 4.86887 9.97415 4.73882 9.92384 4.61751C9.87353 4.49619 9.79979 4.38599 9.70685 4.2932L5.70685 0.293201C5.61406 0.200255 5.50385 0.126518 5.38254 0.0762068C5.26122 0.0258961 5.13118 0 4.99985 0C4.86851 0 4.73847 0.0258961 4.61715 0.0762068C4.49584 0.126518 4.38563 0.200255 4.29285 0.293201L1.58085 3.0052C1.20085 3.3852 0.986845 3.9072 0.994845 4.4402C1.01785 5.8642 1.39485 10.8102 5.29285 14.7082C9.19085 18.6062 14.1368 18.9822 15.5618 19.0062H15.5898C16.1178 19.0062 16.6168 18.7982 16.9948 18.4202L19.7068 15.7082C19.7998 15.6154 19.8735 15.5052 19.9238 15.3839C19.9742 15.2626 20 15.1325 20 15.0012C20 14.8699 19.9742 14.7398 19.9238 14.6185C19.8735 14.4972 19.7998 14.387 19.7068 14.2942L15.7068 10.2932ZM15.5798 17.0052C14.3318 16.9842 10.0618 16.6492 6.70685 13.2932C3.34085 9.9272 3.01485 5.6422 2.99485 4.4192L4.99985 2.4142L7.58585 5.0002L6.29285 6.2932C6.17531 6.41065 6.08889 6.55554 6.0414 6.71477C5.99391 6.874 5.98684 7.04256 6.02085 7.2052C6.04485 7.3202 6.63185 10.0472 8.29185 11.7072C9.95185 13.3672 12.6788 13.9542 12.7938 13.9782C12.9564 14.0132 13.1251 14.0067 13.2845 13.9593C13.4439 13.9119 13.5888 13.8253 13.7058 13.7072L14.9998 12.4142L17.5858 15.0002L15.5798 17.0052V17.0052Z"
      fill="#CDB757"
    />
  </svg>
);

const Mail = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 0H2C0.897 0 0 0.897 0 2V14C0 15.103 0.897 16 2 16H18C19.103 16 20 15.103 20 14V2C20 0.897 19.103 0 18 0ZM18 2V2.511L10 8.734L2 2.512V2H18ZM2 14V5.044L9.386 10.789C9.56111 10.9265 9.77733 11.0013 10 11.0013C10.2227 11.0013 10.4389 10.9265 10.614 10.789L18 5.044L18.002 14H2Z"
      fill="#CDB757"
    />
  </svg>
);

// markup
const Informations = () => {
  return (
    <Layout>
      <div className="informations">
        <div className="pageTitle">
          <h1>Informations pratiques</h1>
        </div>

        <div className="boxContent">
          <h2 className="boxContent-title">Horaires d’ouverture</h2>
          <Tabs>
            <div>
              {/* <ul>
                <li>Mardi : 14h à 18h</li>
                <li>Mercredi : 10h à 12h30 et 14h à 18h</li>
                <li>Jeudi : 14h à 18h</li>
                <li>Vendredi : 14h à 18h</li>
                <li>Samedi : 10h à 12h30 et 14h à 17h</li>
              </ul> */}
              <a
                href="https://www.tourisme-bocage.com/toute-l-offre/mediatheque-de-mauleon-2597657"
                target="_blank"
              >
                Horaires de la Médiathèque
              </a>
            </div>
            <div>
              <a
                href="https://www.tourisme-bocage.com/visiter/histoire-et-patrimoine/musee-l-abbaye-mauleon-107090"
                target="_blank"
              >
                Horaires du Musée
              </a>
            </div>
            <div>
              <a
                href="https://www.tourisme-bocage.com/toute-l-offre/office-de-tourisme-du-bocage-bressuirais-mauleon-1260886"
                target="_blank"
              >
                Horaires de l'Office de tourisme
              </a>
            </div>
          </Tabs>
        </div>

        <div className="boxContent">
          <h2 className="boxContent-title">Plan d’accès</h2>
          <p>
            L’Abbaye <br />
            Place de l’Hôtel de Ville <br />
            79700 MAULEON <br />
          </p>
          <div className="pic">
            <StaticImage
              src="../images/map.png"
              alt="A dinosaur"
              layout="fullWidth"
            />
          </div>
          <div className="listLinks">
            <a
              href="https://www.google.fr/maps/search/L%E2%80%99Abbaye+Place+de+l%E2%80%99H%C3%B4tel+de+Ville+79700+MAULEON/@46.9227614,-0.7531635,17z/data=!3m1!4b1"
              target="_blank"
            >
              Voir sur Google Maps
              <Arrow />
            </a>
            <a
              href="https://maps.apple.com/?address=Place%20de%20l'H%C3%B4tel%20de%20Ville,%2079700%20Maul%C3%A9on,%20France&ll=46.922548,-0.750251&q=Place%20de%20l'H%C3%B4tel%20de%20Ville&_ext=EiYpXEO83IJ1R0Ax8dtJT+w36L852hjiOKl2R0BB0291+yzM579QBA%3D%3D"
              target="_blank"
            >
              Voir sur Apple Maps
              <Arrow />
            </a>
            {/* <a href="#" target="_blank">
              Voir sur OpenStreetMap
              <Arrow />
            </a> */}
            <a
              href="https://www.bing.com/maps?osid=13d4ec93-4436-44ac-9b2c-e071c876c997&cp=46.922821~-0.755661&lvl=16&imgid=1db35b56-99f6-4343-b5f0-a93fb344b111&v=2&sV=2&form=S00027"
              target="_blank"
            >
              Voir sur Bing Maps
              <Arrow />
            </a>
          </div>
        </div>

        <div className="boxContent">
          <h2 className="boxContent-title">Contacts</h2>
          <Tabs>
            <div className="contactLinks">
              <div>
                <Phone /> 05 49 81 17 14
              </div>
              <div>
                <Mail /> mediatheque.mauleon@agglo2b.fr
              </div>
            </div>
            <div className="contactLinks">
              <div>
                <Phone /> 05 49 74 32 24
              </div>
              <div>
                <Mail /> musees@agglo2b.fr
              </div>
            </div>
            <div className="contactLinks">
              <div>
                <Phone /> 05 49 65 10 27
              </div>
              <div>
                <Mail /> info@tourisme-bocage.com
              </div>
            </div>
          </Tabs>
        </div>

        <div className="boxContent">
          <h2 className="boxContent-title">
            Tourisme et Handicap : préparez votre visite à l'Abbaye
          </h2>

          <Tabs
            // titles={["Accessibilité", "Outils de médiation <br />en place"]}
            titles={["Accessibilité"]}
          >
            <div>
              <h3>
                Le site de l’Abbaye est engagé dans une démarche label “Tourisme
                et Handicap” : Auditif, Mental, Moteur.
              </h3>
              <StaticImage
                src="../images/handicap/1.jpg"
                alt="Tourisme et handicap"
                layout="fullWidth"
              />
              <p></p>
              <p>
                A ce jour, sont en place, les aménagements pour les situations
                de handicap suivantes :
              </p>

              <p className="titleImg">
                <StaticImage
                  src="../images/handicap/handicap_moteur.png"
                  alt="Tourisme et handicap"
                  width="30"
                  // layout="fullWidth"
                />
                <span>Handicap moteur :</span>
              </p>

              <ul>
                <li>
                  1 Place de parking réservée PMR devant le site : Place du
                  Renard (place pavée) – environ 100 m,
                </li>
                <li>
                  Carillon d’appel à l’entrée du bâtiment pour une aide à
                  l’accès,
                </li>
                <li>
                  Signalétique directionnelle visible et repérage par
                  pictogrammes,
                </li>
                <li>
                  Mobiliers d’accueil adaptés à la Médiathèque, au Musée et à
                  l’Office de Tourisme,
                </li>
                <li>
                  Mise à disposition d’un fauteuil roulant et de pliants à
                  l’entrée du bâtiment sur demande,
                </li>
                <li>Accès aux étages par ascenseur,</li>
                <li>
                  Espaces de circulation aux normes d'accessibilité : Les
                  escaliers sont équipés de mains courantes,
                </li>
                <li>Sanitaires PMR au rez-de-chaussée et 1er étage,</li>
                <li>Repérage par code couleur au Musée,</li>
                <li>
                  Des assises fréquentes sont proposées dans les collections
                  permanentes du Musée
                </li>
              </ul>

              <p className="titleImg">
                <StaticImage
                  src="../images/handicap/handicap_auditif.png"
                  alt="Tourisme et handicap"
                  width="30"
                  // layout="fullWidth"
                />
                <span>Handicap auditif :</span>
              </p>

              <ul>
                <li>
                  Boucle magnétique à l’accueil de l’Office du tourisme et de la
                  Médiathèque,
                </li>
                <li>Panneaux de présentation des collections du Musée,</li>
                <li>Ecrans numériques sous-titrés au Musée,</li>
                <li>Signalétique directionnelle visible,</li>
                <li>Repérage par code couleur au Musée</li>
              </ul>

              <p className="titleImg">
                <StaticImage
                  src="../images/handicap/handicap_mental.png"
                  alt="Tourisme et handicap"
                  width="30"
                  // layout="fullWidth"
                />
                <span>Handicap mental :</span>
              </p>

              <ul>
                <li>
                  Signalétique directionnelle visible et repérage par
                  pictogrammes,
                </li>
                <li>Repérage par code couleur au Musée,</li>
                <li>
                  Collections Facile à Lire et Dys à la Médiathèque : Livres
                  illustrés, romans courts, livres lus, revues,
                </li>
                <li>
                  Guide de visite en langage Facile à Lire – Facile à Comprendre
                  au Musée,
                </li>
                <li>Parcours enfant ludique et audio-guide enfant au Musée,</li>
              </ul>

              <p className="titleImg">
                <StaticImage
                  src="../images/handicap/visuel.png"
                  alt="Tourisme et handicap"
                  width="30"
                  // layout="fullWidth"
                />
                <span>Handicap visuel :</span>
              </p>

              <p className="infoEncadre">
                Pour des contraintes de bâtiment, le label handicap visuel ne
                peut pas être attribué. <br /> Pour un plus grand confort de
                visite, il est recommandé de venir accompagné (e).
              </p>

              <p>Toutefois, de nombreux aménagements existent : </p>
              <ul>
                <li>
                  Chien guide ou d’assistance accepté sur l’intégralité du site
                </li>
                <li>
                  Ascenseur équipé de boutons avec indications en relief et
                  braille ainsi que d’une annonce sonore des niveaux.
                </li>
                <li>
                  Espaces de circulation aux normes d'accessibilité : escaliers
                  équipés de mains courantes et clous et bandes podotactiles
                </li>
                <li>
                  Romans et documents en gros caractères, livres lus et matériel
                  d’aide à la lecture : prêt de lunettes, loupes, lampes et
                  lecteur Daisy en prêt gratuit à la Médiathèque
                </li>
                <li>
                  Audio-guide avec clavier braille et boucle à induction
                  magnétique au Musée
                </li>
                <li>
                  Quelques fac-similés et éléments à toucher dans le parcours du
                  Musée
                </li>
              </ul>

              <p>
                Au-delà des aménagements existants, l’ensemble du personnel est
                sensibilisé à l’accueil des personnes en situation de handicap.{" "}
              </p>
              <p>
                Au Musée : des visites guidées avec un médiateur formé et
                sensibilisé sont proposées aux groupes de personnes en situation
                de handicap, sur réservation.
              </p>
              <p>
                Afin de préparer au mieux votre visite et adapter notre accueil
                à vos besoins, vous pouvez nous contacter au préalable.
              </p>
              <p>
                Musée 05 49 74 32 24 <br />
                Médiathèque 05 49 81 17 14 <br />
                Office du Tourisme 05 49 65 10 27
              </p>
            </div>

            <div></div>
          </Tabs>
        </div>
      </div>
    </Layout>
  );
};

export default Informations;
